import {
  Button,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Form } from "../../../layout";
import { Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { AppContext } from "../../../App";

import * as actions from "../../../api/actions/pos";
import { controller, endpoints } from "../../../api/actions/api";
import { ToFormData } from "../../../hooks/Method";

const SendFrgtCode = (props) => {
  const { _getByObj, setActiveStep, forgotVal, setForgotVal } = props;

  const { ForgotMdl } = Model();
  const { setCLoader } = useContext(AppContext);
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const [errMsg, setErrMsg] = useState("");

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
  } = UseForm(ForgotMdl);

  //----------------------------------------
  // Language
  //----------------------------------------
  const handleLanguageChange = (e) => {
    const language = e.target.value;

    i18n.changeLanguage(language);
    localStorage.setItem("posLanguage", language);
  };

  //----------------------------------------
  // Validation
  //----------------------------------------
  const validateForm = () => {
    const temp = {};

    temp.companyCode = values.companyCode?.trim()
      ? ""
      : t("companyCodeRequired");

    temp.userName = values.userName?.trim()
      ? ""
      : t("userNameRequired");

    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };

  //----------------------------------------
  // Submit Forgot Password
  //----------------------------------------
  const submitForm = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setErrMsg("");
    setCLoader(true);

    const onComplete = (res, err) => {
      setCLoader(false);

      // Network or server error
      if (err || !res) {
        setErrMsg(
          err?.error?.msg ||
          err?.msg ||
          err?.message ||
          t("requestFailed")
        );
        return;
      }

      // Success
      if (res.status === 200) {
        setForgotVal((prev) => ({
          ...prev,
          companyCode: values.companyCode.trim().toUpperCase(),
          userName: values.userName.trim(),
          forgotStep: 1,
        }));

        setActiveStep(1);
        return;
      }

      // Rejected request
      if (res.status === 204) {
        setErrMsg(res.msg || t("requestFailed"));
        return;
      }

      setErrMsg(res.msg || t("requestFailed"));
    };

    const requestValues = {
      companyCode: values.companyCode.trim().toUpperCase(),
      userName: values.userName.trim(),
      forgotStep: 1,
    };

    _getByObj(
      endpoints.Auth + controller.Forgot,
      ToFormData(requestValues),
      actions.ActionType.Data,
      onComplete
    );
  };

  //----------------------------------------
  // Restore previous forgot-password data
  //----------------------------------------
  useEffect(() => {
    if (forgotVal) {
      setValues({
        ...ForgotMdl,
        ...forgotVal,
        companyCode: forgotVal.companyCode || "",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //----------------------------------------
  // Preserve values between recovery steps
  //----------------------------------------
  useEffect(() => {
    setForgotVal({ ...values });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <Form noValidate onSubmit={submitForm}>
      <Grid
        container
        className="p-15 pt-0"
        maxWidth={400}
        spacing={3}
      >
        {/* Language */}
        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>{t("language")}</InputLabel>

            <Select
              value={i18n.language}
              label={t("language")}
              onChange={handleLanguageChange}
            >
              <MenuItem value="en">{t("english")}</MenuItem>
              <MenuItem value="fr">{t("french")}</MenuItem>
              <MenuItem value="es">{t("spanish")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Title */}
        <Grid item xs={12} className="tx-center gray-color">
          <Grid className="pos-relative mb-20">
            <span className="fw-6 fs-20 tx-upp">
              {t("forgotPassword")}
            </span>

            <div className="bs-bottom mx-w-60 m-auto mt-5" />
          </Grid>
        </Grid>

        {/* Error message */}
        {errMsg && (
          <Grid item xs={12} className="tx-center">
            <Typography color="error">
              {errMsg}
            </Typography>
          </Grid>
        )}

        {/* Company Code */}
        <Grid item xs={12}>
          <Input
            label={t("companyCode")}
            name="companyCode"
            value={values.companyCode || ""}
            onChange={handleInpChg}
            error={errors.companyCode}
            className="input-primary w-100pr"
            placeholder={t("companyCodePlaceholder")}
          />
        </Grid>

        {/* Username */}
        <Grid item xs={12}>
          <Input
            label={t("username")}
            name="userName"
            value={values.userName || ""}
            onChange={handleInpChg}
            error={errors.userName}
            className="input-primary w-100pr"
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} className="text-center">
          <Button
            type="submit"
            size="large"
            className="btn-secondary w-100pr mb-10"
          >
            {t("sendVerificationCode")}
          </Button>

          <Button
            type="button"
            onClick={() => navigate("/auth")}
            size="large"
            className="btn-primary w-100pr"
          >
            {t("back")}
          </Button>
        </Grid>
      </Grid>
    </Form>
  );
};

const mapStateToProps = () => ({});

const mapActionToProps = {
  _getByObj: actions.getByObj,
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(SendFrgtCode);